var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 13.75,
    viewBox: "0 0 11 13.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location_line",
    "data-name": "Location line",
    transform: "translate(-74 -947.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location_on_FILL0_wght400_GRAD0_opsz48",
    d: "M13.5,10.7a1.2,1.2,0,1,0-.851-.352A1.159,1.159,0,0,0,13.5,10.7Zm0,5.689a20.13,20.13,0,0,0,3.377-3.773,5.724,5.724,0,0,0,1.091-2.982,4.474,4.474,0,0,0-1.3-3.317A4.328,4.328,0,0,0,13.5,5.031,4.328,4.328,0,0,0,10.329,6.32a4.474,4.474,0,0,0-1.3,3.317,5.64,5.64,0,0,0,1.117,2.982A21.859,21.859,0,0,0,13.5,16.392Zm0,1.358a22.855,22.855,0,0,1-4.134-4.374A6.8,6.8,0,0,1,8,9.637,5.317,5.317,0,0,1,9.659,5.53a5.588,5.588,0,0,1,7.683,0A5.317,5.317,0,0,1,19,9.637a6.8,6.8,0,0,1-1.366,3.738A22.855,22.855,0,0,1,13.5,17.75ZM13.5,9.637Z",
    transform: "translate(66 943.13)",
    fill: "#66939e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationLine);
export default __webpack_public_path__ + "static/media/location_line.2ae0d2e9b31590a10edb586c0f242bf6.svg";
export { ForwardRef as ReactComponent };